import { Group } from './group'

export enum Type {
  PERSONAL = 'personal',
  TEAM = 'team',
}

export type Filters = {
  query: string
  groups: Group[]
}

export type Paging = {
  per_page: number
  current_page: number
  next_page: number | null
  prev_page: number | null
  total_pages?: number
}

export type Metadata = {
  paging: Paging
}
